import {Component, Input} from '@angular/core';

@Component({
  selector: 'ubi-card',
  templateUrl: './ubiCard.html',
})
export class UbiCard {
  @Input() title:String;
  @Input() baCardClass:String;
  @Input() cardType:String;
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiCard/ubiCard.component.ts